/* eslint-disable no-unused-vars */
import React from 'react';
import classes from './AiLoader.module.css';
import CircularProgress from '@mui/material/CircularProgress';

function AiLoader({ isLoading, text }) {
  return (
    <div>
      {isLoading && (
        <div className={classes.main}>
          {' '}
          <div className={classes.box}>
            <div className={classes.loader}>
              <div className={classes.o}></div>
              <div className={classes.o}></div>
              <div className={classes.o}></div>
              <div className={classes.o}></div>
            </div>
            <div className={classes.text}>{text}</div>
          </div>{' '}
    
        </div>
      )}
    </div>
  );
}

export default AiLoader;
